import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 17v4.25a.5.5 0 01-.596.484c-.096-.019-.254-.134-.254-.134L12 19l-3.65 2.6s-.158.115-.254.134a.499.499 0 01-.596-.484V14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.214 9.133c-.617-.457-.148-1.363.02-1.633-.303.334-.605.662-.836 1.022-.367.566-.527 1.19-.277 1.588.45.72 1.524.385 2.205.096l6.35-2.68-6.273 1.658c-.527.135-.951.122-1.19-.051z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 17v4.25a.5.5 0 01-.596.484c-.096-.019-.254-.134-.254-.134L12 19l-3.65 2.6s-.158.115-.254.134a.499.499 0 01-.596-.484V14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.214 9.133c-.617-.457-.148-1.363.02-1.633-.303.334-.605.662-.836 1.022-.367.566-.527 1.19-.277 1.588.45.72 1.524.385 2.205.096l6.35-2.68-6.273 1.658c-.527.135-.951.122-1.19-.051z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33 34v8.5a1 1 0 01-1.191.968c-.192-.038-.509-.268-.509-.268L24 38l-7.3 5.2s-.317.23-.509.267A1 1 0 0115 42.5V28"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 31.5c7.456 0 13.5-6.044 13.5-13.5S31.456 4.5 24 4.5 10.5 10.544 10.5 18 16.544 31.5 24 31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.428 18.265c-1.234-.913-.296-2.725.038-3.265-.604.668-1.208 1.324-1.67 2.044-.734 1.131-1.055 2.378-.554 3.175.9 1.44 3.047.772 4.41.193l12.7-5.36-12.546 3.316c-1.054.27-1.903.244-2.378-.103z"
  }))
};
export var MemberRewards = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});